export default __webpack_public_path__ + "static/media/trees-henry-crop.cc4316ac.jpg";